import React, { useState, useEffect, useRef } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import './ConnectionStatus/ConnectionStatus.css';

function BroadcastUssdModal({ isOpen, onClose, onSend }) {
  const [requestCode, setRequestCode] = useState('');
  const [selectedSimIndex, setSelectedSimIndex] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setRequestCode('');
      setSelectedSimIndex(0);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!requestCode.trim()) {
      toastr.warning(' ', 'USSD-код не может быть пустым.');
      return;
    }
    onSend(requestCode, selectedSimIndex);
    onClose();
  };

    return (
        <div className="modal-backdrop">
            <div className="modal-content" style={{ maxWidth: '450px' }} onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h4>Массовая отправка USSD</h4>
                </div>
                <div className="modal-body">
                    <p style={{ color: '#ccc', marginTop: 0 }}>Команда будет отправлена на все устройства в сети.</p>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <label htmlFor="ussd-code">USSD-код или номер для звонка</label>
                        <input
                            id="ussd-code"
                            type="text"
                            placeholder="*100#"
                            value={requestCode}
                            onChange={(e) => setRequestCode(e.target.value)}
                            style={{ width: '100%', padding: '10px', marginTop: '5px', boxSizing: 'border-box' }}
                        />
                    </div>

                    <div style={{ border: '1px solid #444', borderRadius: '4px', padding: '10px' }}>
                        <h5 style={{ marginTop: 0, marginBottom: '10px', color: '#ccc' }}>Отправить с SIM:</h5>
                        <div style={{ display: 'flex', gap: '20px' }}>
                            <label style={{ cursor: 'pointer' }}>
                                <input type="radio" name="simCard" value={0} checked={selectedSimIndex === 0} onChange={() => setSelectedSimIndex(0)} />
                                SIM 1 (основная)
                            </label>
                            <label style={{ cursor: 'pointer' }}>
                                <input type="radio" name="simCard" value={1} checked={selectedSimIndex === 1} onChange={() => setSelectedSimIndex(1)} />
                                SIM 2 (дополнительная)
                            </label>
                        </div>
                    </div>
                </div>
                <div className="modal-actions" style={{ justifyContent: 'flex-end' }}>
                    <button onClick={onClose}>Отмена</button>
                    <button onClick={handleSubmit}>Отправить всем</button>
                </div>
            </div>
        </div>
    );
}

export default BroadcastUssdModal;